<template>
<div>
    <b-row>
        <b-colxx xxs="12">
            <b-card class="mb-4">
                <b-row class="mb-5">
                    <b-col xxs="12">
                        <b-input-group>
                            <template v-slot:prepend>
                                <b-button @click="onClickPrev()" variant="outline-primary">◀</b-button>
                            </template>
                            <v-date-picker mode="single" v-model="searchDate" :input-props="{ class:'form-control', placeholder: '' }">
                            </v-date-picker>
                            <template v-slot:append>
                                <b-input-group-text class="d-none d-xs-block">
                                    <b-icon icon="calendar"></b-icon>
                                </b-input-group-text>
                                <b-button @click="onClickNext()" variant="outline-primary">▶</b-button>
                            </template>
                        </b-input-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-colxx xxs="12" md="4" lg="3" xl="3" class="pr-0">
                        <div class="form-group has-float-label">
                            <v-select :options="searchOptions" v-model="searchKind" :reduce="item=>item.value" label="label"></v-select>
                        </div>
                    </b-colxx>

                    <b-colxx xxs="12" md="6" lg="4" xl="4">
                        <b-input-group>
                            <b-input :placeholder="searchPlaceholder" v-model.trim="searchKeyword" :maxlength="searchKind == 'PhoneNumber4' ? 4 : 13" @input="onlyNumberCheck" @keyup.enter="onSearch" />
                            <b-input-group-append>
                                <b-button v-show="!searchFlag" @click="onSearch" variant="outline-primary default" :class="searchFlag ? '' : 'd-none d-sm-block'">
                                    {{ $t('button.search') }}
                                </b-button>
                                <b-button v-show="searchFlag" @click="searchCancel" variant="outline-primary default" :class="searchFlag ? 'd-none d-sm-block' : ''">
                                    {{ $t('button.search-cancel') }}
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-colxx>

                    <b-row class="mb-3 d-block d-sm-none d-md-none">
                        <!-- 모바일 사이즈일때 -->
                        <b-colxx xxs="12">
                            <b-input-group>
                                <b-input :placeholder="searchPlaceholder" v-model="searchKeyword" size="md" @input="onlyNumberCheck" />
                                <b-button v-show="!searchFlag" @click="onSearch" variant="outline-primary default" size="sm">
                                    {{ $t('button.search') }}
                                </b-button>
                                <b-button v-show="searchFlag" @click="searchCancel" variant="outline-primary default" size="md">
                                    {{ $t('button.search-cancel') }}
                                </b-button>
                            </b-input-group>
                        </b-colxx>
                    </b-row>
                </b-row>

                <template v-if="isLoad">

                    <booking-list :items="items" :fields="fields" :per-page="perPage" :currentPage="currentPage" @click-row="onClickRow"  @visited-cancel="visitedShow" />

                    <b-pagination v-if="lastPage > 1" size="sm" align="center" :total-rows="total" :per-page="perPage" v-model="currentPage">
                        <template v-slot:next-text>
                            <i class="simple-icon-arrow-right" />
                        </template>
                        <template v-slot:prev-text>
                            <i class="simple-icon-arrow-left" />
                        </template>
                        <template v-slot:first-text>
                            <i class="simple-icon-control-start" />
                        </template>
                        <template v-slot:last-text>
                            <i class="simple-icon-control-end" />
                        </template>
                    </b-pagination>
                </template>

                <template v-else>
                    <div class="loading"></div>
                </template>

                <template>
                    <b-row align-v="center" align-h="center" class="mt-0" no-gutters>
                        <div class="notooltip">
                            <b-modal modal-class="notooltip" id="bookingdetails" ref="bookingdetails" size="lg" title="예약 상태" :hide-backdrop="false" :no-close-on-backdrop="true">
                                <!-- <booking-visit-detail @noPenaltyVisitEve="noPenaltyVisitEve" v-bind:data="bookingInfo" :modifyFlag="false" :checkUseFlag="bookingInfo.bookingStatus === 'Booked' ? true : false" /> -->
                                <booking-visit-detail @noPenaltyVisitEve="noPenaltyVisitEve" v-bind:data="bookingInfo" @searchData="searchData" @hideModal="hideModal" @cancelRespar="cancelRespar" :modifyFlag="false" :checkUseFlag="bookingInfo.bookingStatus === 'Booked' ? true : false" />

                                <template slot="modal-footer">
                                    <b-button variant="outline-primary" @click="hideModal()" class="" v-show="cancelResparvar">닫기</b-button>
                                    <!-- <b-button variant="danger" @click="cancelReservation" v-if="bookingInfo.bookingStatus === 'Booked'">
                      예약취소
                    </b-button>
                    <b-button variant="danger" class="mr-1" @click="setNoShow"
                              v-if="bookingInfo.bookingStatus === 'Booked'">노쇼
                    </b-button> -->
                                    <b-button variant="primary" @click="setVisited()" v-if="bookingInfo.bookingStatus === 'Booked'" v-show="cancelResparvar" class="mr-1">방문완료처리
                                    </b-button>
                                </template>

                            </b-modal>
                        </div>
                    </b-row>
                </template>

                <!-- 예약방문 처리내역 조회모달  -->
                <booking-visited-cancel ref="modal_visited_cancel" :data="visitedInfo" :noShowFlag="noShowFlag" @process="visitedCancel" @noshow="cancelNoShow" />
            </b-card>
        </b-colxx>
    </b-row>
</div>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import api from '../../constants/api'
import BookingVisitDetail from '../../views/booking/components/BookingDetailView'
import BookingList from "../../views/booking/components/BookingList";
import {
    alignTableCenter
} from '../../utils';
import BookingVisitedCancel from "../../views/booking/components/BookingVisitedCancel";

import {
    mapGetters,
    mapActions,
    mapMutations
} from "vuex";

export default {
    name: 'BookingModal',
    components: {
        'v-select': vSelect,
        'booking-visit-detail': BookingVisitDetail,
        'booking-list': BookingList,
        'booking-visited-cancel': BookingVisitedCancel
    },
    props: ['data', 'dateData', 'topBookingBtn', 'calendarType', 'calendarTime','timeUnit', 'storeCode'],

    data() {
        return {
            cancelResparvar: true,
            noPenalty: false,
            noShowFlag: null,
            transProps: {
                // Transition name
                name: 'list'
            },
            searchKind: 'PhoneNumber4',
            searchOptions: [{
                    label: '전화번호',
                    value: 'PhoneNumber4'
                },
                {
                    label: '예약번호',
                    value: 'BookingNo'
                },
            ],
            searchDate: this.$route.query.searchDate ? this.$moment(this.$route.query.searchDate).toDate() : new Date(),
            isLoad: false,
            searchFlag: false,
            currentPage: 1,
            perPage: 30,
            lastPage: 1,
            total: 1,
            searchKeyword: "",
            items: [],
            fields: [{
                    key: 'bookingNo',
                    label: "예약번호",
                    ...alignTableCenter
                },
                {
                    key: 'storeName',
                    label: "매장명",
                    ...alignTableCenter
                },
                {
                    key: 'visitorName',
                    label: "예약자",
                    ...alignTableCenter
                },
                {
                    key: 'visitorPhone',
                    label: "전화번호",
                    ...alignTableCenter
                },
                {
                    key: 'reservationDate',
                    label: "방문예정일",
                    ...alignTableCenter
                },
                {
                    key: 'reservationDateTime',
                    label: "방문예정시간",
                    ...alignTableCenter
                },
                {
                    key: 'headcount',
                    label: "인원",
                    ...alignTableCenter
                },
                {
                    key: 'bookingStatus',
                    label: "상태",
                    ...alignTableCenter
                },
                {
                    key: 'freeBooking',
                    label: "예약경로",
                    ...alignTableCenter
                },
            ],
            bookingInfo: {
                bookingNo: null,
                visitorName: null,
                visitorPhone: null,
                visitorRequests: null,
                storeName: null,
                reservationDate: null,
                bookingRequestDate: null,
                bookingStatus: null,
                orderItems: [],
            },
            selectedBookingNo: null,
            visitedInfo: [],
        }
    },

    mounted() {

        this.searchKeyword = this.data;
        // console.log(this.topBookingBtn)
        if (this.topBookingBtn == true) {
            this.searchData()
        }
        if (this.searchKeyword == '') {
            this.searchData()
            // console.log("this.searchKeyword != ''")
        }

        if (this.dateData) {
            this.searchDate = this.dateData;
        }
    },

    watch: {
        currentPage() {
            this.searchData()
            // console.log('currentPage()')
        },
        searchDate(value) {
            if (value) {
                this.searchData()
                // console.log('searchDate(value)')
            }
        },
        noShowFlag() {}
    },

    computed: {
        ...mapGetters(['currentUser', 'siteName']),
        searchPlaceholder: {
            get: function () {
                return this.searchKind === "PhoneNumber4" ? "전화번호 뒷4자리를 입력하세요." : "예약번호를 입력하세요";
            }
        }
    },

    methods: {
        cancelRespar(val) {
            this.cancelResparvar = val;
        },
        onlyNumberCheck(value) {
            let val = value.replace(/[^0-9]/g, '')
            this.searchKeyword = val
        },
        showModal() {
            this.$refs['bookingdetails'].show();
        },
        hideModal() {
            this.$refs['bookingdetails'].hide();
        },
        onClickPrev() {
            this.searchDate = this.$moment(this.searchDate).subtract(1, 'day').toDate()
        },
        onClickNext() {
            this.searchDate = this.$moment(this.searchDate).add(1, 'day').toDate()
        },

        onSearch() {
            if (this.searchKeyword === "") {
                alert('검색어를 숫자만 입력하세요');
                return false
            }
            this.currentPage = 1
            // this.searchFlag = true
            this.searchData()
        },

        searchCancel() {
            this.searchFlag = false
            this.searchKeyword = ""
            this.searchData()
        },

        /** *************************************************************************************************************/
        searchData() {
            this.isLoad = true;
            this.items = [];
            // console.log(this.searchKeyword)
            let timestart = '';
            let timeend = '';
            let timestartstrmHours = this.calendarTime.substring(0, 2);
            let timestartstrmmintus = this.calendarTime.substring(3, 5);
            if (this.calendarType === 'w') {
                if (this.timeUnit === 'M30') {
                    if (timestartstrmmintus === '00') {
                        timestart = this.calendarTime + ':00';
                        timeend = timestartstrmHours + ':' + '29:00';
                    } else {
                        timestart = this.calendarTime + ':00';
                        timeend = timestartstrmHours + ':' + '59:00';
                    }
                } else {
                    timestart = this.calendarTime + ':00';
                    timeend = timestartstrmHours + ':' + '59:00';
                }
            }
            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.bookingList)

            let _keywordType = this.searchKeyword === "" ? "NoKeyword" : this.searchKind //키워드 내용없을경우
            const params = {
                dateType: 'VisitDate',
                dateFrom: this.$moment(this.searchDate).format('YYYY-MM-DD'),
                dateTo: this.$moment(this.searchDate).format('YYYY-MM-DD'),
                keywordType: _keywordType,
                keyword: this.searchKeyword,
                pageNumber: (this.currentPage - 1),
                pageSize: this.perPage,
                timeFrom: timestart,
                timeTo: timeend,
                storeCode:this.storeCode
            }

            this.$http.post(reqURL, params, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    //
                    console.log(res.data.data);
                    const _data = res.data.data
                    this.lastPage = _data.totalPages
                    this.total = _data.totalElements
                    // this.items = _data.content;
                    let goods2 = _data.content;
                    this.items = goods2;
                    // console.log(this.lastPage);
                    // console.log(this.lastPage > 1)

                } else {
                    throw 400
                }
            }).catch(err => {
                alert(err.response.data.message);
            })

        },

        onClickRow(item, bookingNo) {
            this.selectedBookingNo = bookingNo
            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.bookingDetail)
            const params = {
                bookingNo: bookingNo
            }

            //예약정보 불러오기 필요.
            this.$http.post(reqURL, params, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    this.bookingInfo = res.data.data.bookingDetails
                    this.noPenalty = true;
                    this.showModal();
                } else {
                    throw 400
                }
            }).catch(err => {
                alert(err.response.data.message);
            })
        },

        //예약취소
        cancelReservation() {

            // if (confirm('해당 예약을 취소하시겠습니까? ')) {
            //     const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.cancelBooking)
            //     const params = {
            //         bookingNo: this.selectedBookingNo
            //     }

            //     this.$http.post(reqURL, params, {
            //         headers: {
            //             'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
            //         }
            //     }).then(res => {
            //         if (res.data.code === "OK") {
            //             alert('해당 예약이 취소 되었습니다.');
            //             this.hideModal()
            //             this.searchData()
            //         } else {
            //             throw 400
            //         }
            //     }).catch(err => {
            //         alert(err.response.data.message);
            //     })
            // }

        },

        //예약노쇼처리
        setNoShow() {

            if (confirm('노쇼처리 하시겠습니까? ')) {
                const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.noShow)
                const params = {
                    memo: "노쇼처리 함",
                    bookingNo: this.selectedBookingNo
                }

                this.$http.post(reqURL, params, {
                    headers: {
                        'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                    }
                }).then(res => {
                    if (res.data.code === "OK") {
                        alert('노쇼처리 되었습니다.');
                        this.hideModal()
                        this.searchData()
                    } else {
                        throw 400
                    }
                }).catch(err => {
                    alert(err.response.data.message);
                })
            }
        },

        //노쇼취소처리
        cancelNoShow(memo) {

            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.cancelNoShow)
            const params = {
                memo: memo,
                bookingNo: this.selectedBookingNo,
                transactionNo: this.visitedInfo.transactionNo
            }

            this.$http.post(reqURL, params, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    alert('노쇼취소처리 되었습니다.')
                    this.searchData()
                } else {
                    throw 400
                }
            }).catch(err => {
                alert(err.response.data.message);
            })

        },
        noPenaltyVisitEve(val) {
            if (val == true) {
                this.noPenalty = false;
            } else {
                this.noPenalty = true;
            }
            console.log(this.noPenalty)
        },

        //예약방문처리
        setVisited() {
            let errFlag = true

            let selectedItemIds = [];
            let orderItemTotal = this.bookingInfo.orderItems.length;
            let cancellationFeeRate = this.bookingInfo.cancellationFeeRate;
            let noPenalty = this.noPenalty;

            this.bookingInfo.orderItems.forEach(function (value, index) {
                if (value.unused) {
                    selectedItemIds.push(value.itemNo)
                    errFlag = false
                }
            })

            if (errFlag) {
                alert('방문완료 처리 할 쿠폰을 선택해주세요.')
                return false
            }
            if (confirm(this.getMessage(orderItemTotal, selectedItemIds.length, cancellationFeeRate, noPenalty))) {
                //방문완료 처리 필요
                const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.visitStore)
                const params = {
                    bookingNo: this.selectedBookingNo,
                    orderItems: selectedItemIds,
                    memo: null,
                    noPenalty: this.noPenalty,
                }

                console.log(params)

                this.$http.post(reqURL, params, {
                    headers: {
                        'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                    }
                }).then(res => {
                    if (res.data.code === "OK") {
                        alert('처리 완료 하였습니다.')
                        this.hideModal()
                        this.searchData()
                    } else {
                        throw 400
                    }
                }).catch(err => {
                    alert(err.response.data.message);
                })
            }
        },
      getMessage(orderItemTotal, selectedItemTotal, cancellationFeeRate, noPenalty){
        let resultMessage = "";
        let cancelFee =  orderItemTotal - selectedItemTotal;
        if(cancellationFeeRate == "0.0" && !(orderItemTotal === selectedItemTotal)){
          resultMessage = selectedItemTotal + "매 방문완료 처리하시겠습니까? \n" +
            "- 방문완료 : "+selectedItemTotal + "매 \n" +
            "- 미사용 : "+cancelFee + "매 \n" +
            "- 미사용 환불기준 : 위약금 면제"
        }
        else if(orderItemTotal === selectedItemTotal){
          resultMessage =  orderItemTotal +"매 방문완료 처리하시겠습니까?"
        }else if(noPenalty){
          resultMessage = selectedItemTotal + "매 방문완료 처리하시겠습니까? \n" +
            "- 방문완료 : "+selectedItemTotal + "매 \n" +
            "- 미사용 : "+cancelFee + "매 \n" +
            "- 미사용 환불기준 : 위약금 면제"
        }else {
          resultMessage = selectedItemTotal + "매 방문완료 처리하시겠습니까? \n" +
            "- 방문완료 : "+selectedItemTotal + "매 \n" +
            "- 미사용 : "+cancelFee + "매 \n" +
            "- 미사용 환불기준 : "+ cancellationFeeRate +"%"
        }

        return resultMessage;

      },
        //방문처리내역조회
        visitedShow(item, bookingNo) {
            this.noShowFlag = item.noShow
            this.selectedBookingNo = bookingNo
            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.storeVisitInfo)
            const params = {
                bookingNo: bookingNo
            }
            this.$http.post(reqURL, params, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    console.log(res.data.data)
                    this.visitedInfo = res.data.data
                    this.$refs.modal_visited_cancel.open()
                } else {
                    throw 400
                }
            }).catch(err => {
                alert(err.response.data.message);
            })
        },

        visitedCancel(memo) {

            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.cancelVisitStore)
            const params = {
                bookingNo: this.selectedBookingNo,
                transactionNo: this.visitedInfo.transactionNo
            }

            this.$http.post(reqURL, params, {
                headers: {
                    'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
                }
            }).then(res => {
                if (res.data.code === "OK") {
                    alert('방문취소처리 되었습니다.')
                    this.searchData()
                } else {
                    throw 400
                }
            }).catch(err => {
                alert(err.response.data.message);
            })

        }
    }

}
</script>
